module.exports = __webpack_public_path__ + "media/assets/community/global-e29ac0c91461c704b92b5df5c6732c258cb0b7576f63a0e714174aa1cd75775e.png";